export enum PopupType {
  Pause = 'pause',
  Welcome = 'welcome',
  Settings = 'settings',
  Calendar = 'calendar',
  ChangeDayAd = 'changeDayAd',
  Complete = 'complete',
  NotComplete = 'notComplete',
  Print = 'print',
  RevealPuzzleAd = 'revealPuzzleAd',
  OutOfHintsAd = 'outOfHintsAd',
  ClearPuzzle = 'ClearPuzzle',
  AlreadyRevealedPopup = 'AlreadyRevealedPopup',
}

export enum PrintType {
  Blank = 'blank',
  Entries = 'entries',
  Solution = 'solution',
}

export interface IPopupData {
  type: PopupType;
  data?: any;
}

export interface IUIData {
  popup: IPopupData | null;
  hiddenClues: boolean;
}
